export default __webpack_public_path__ + "static/media/b.7ca0ab70.mp4";